import React from "react";
import { Link } from "react-router-dom";
const Header = () => {
  return (
    <div className="py-8 h-24 border-b border-[rgb(228,228,228)]">
      <div className="flex justify-between items-center lg:px-10 px-4">
        <Link to="/">
          <img
            src={require("n_assets/images/logo.png")}
            alt=""
            className="2xl:max-w-48 xl:max-w-40 lg:max-w-36 md:max-w-32 max-w-28 h-auto mix-blend-multiply"
          />
        </Link>
        <nav className="lg:flex hidden items-center gap-6">
          <Link
            to="/"
            className="font-montserrat text-base text-black font-medium transition-all ease-in-out duration-500 hover:text-coral"
          >
            Home
          </Link>
          <Link
            to="/jobs"
            className="font-montserrat text-base text-black font-medium transition-all ease-in-out duration-500 hover:text-coral"
          >
            Jobs
          </Link>
          <Link
            to="/dashboard/home"
            className="font-montserrat text-base text-black font-medium transition-all ease-in-out duration-500 hover:text-coral"
          >
            Dashboard
          </Link>
          <Link
            to="/faq"
            className="font-montserrat text-base text-black font-medium transition-all ease-in-out duration-500 hover:text-coral"
          >
            FAQ
          </Link>
          <Link
            to="/contact"
            className="font-montserrat text-base text-black font-medium transition-all ease-in-out duration-500 hover:text-coral"
          >
            Contact
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default Header;
